import './process-shim.js';
import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';

import App from './App.vue';
import boots from './boots';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import { languages, defaultLocale } from './i18n/index';

const messages = Object.assign(languages);
const i18n = createI18n({
  allowComposition: true,
  legacy: false,
  globalInjection: true,
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages,
});

const app = createApp(App);

app.use(router);
app.use(store);
app.use(i18n);
app.use(vuetify);

boots({ store, router, app });

app.mount('#app');
